import clsx from 'clsx';
import dynamic from 'next/dynamic';

import { SubheadingBlockFragment } from '@hultafors/hultaforsgroup/types';

import { Button } from '../button/button';

import styles from './subheading-block.module.scss';

const HTag = dynamic(() =>
  import('@hultafors/shared/components').then((mod) => mod.HTag),
);

const Paragraph = dynamic(() =>
  import('@hultafors/shared/components').then((mod) => mod.Paragraph),
);

interface SubheadingBlockProps extends SubheadingBlockFragment {
  priority?: boolean;
}

export const SubheadingBlock: React.FC<SubheadingBlockProps> = ({
  backgroundColor,
  ctaButton,
  text,
  title,
  priority,
}) => {
  const style = {
    ['--background-color' as string]: backgroundColor?.hex,
  };

  return (
    <div className={styles['container']} style={style}>
      <div className={clsx('content-container wide', styles['content'])}>
        <HTag type={priority ? 'h1' : 'h2'} styleType="h3">
          {title}
        </HTag>
        <Paragraph className={styles['paragraph']} styleType="p2-paragraph">
          {text}
        </Paragraph>
        {ctaButton && (
          <Button
            label={ctaButton?.text}
            to={ctaButton?.url}
            className={styles['button']}
            variant={ctaButton?.variant}
          />
        )}
      </div>
    </div>
  );
};
